import { useState } from 'react';
import './App.css';
import { withTranslation } from 'react-i18next';
import ConsentForm from './components/ConsentForm/ConsentForm';
import HolidayMode from './components/HolidayMode/HolidayMode';
import OperationMode from './components/OperationMode/OperationMode';
import ReportingView from './components/Reporting/Reporting';
import LanguageSwitcher from './components/LanguageSwitcher/LanguageSwitcher';
import { Tabs, Tab, Box } from '@mui/material';
import ClipboardIcon from '@mui/icons-material/Assignment';
import TuneIcon from '@mui/icons-material/Tune';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';

function EndUserApp({t, endUserAppConfig}) {
  const [consentSubmitted, setConsentSubmitted] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const tabs = [];

  if (endUserAppConfig.holidayModeEnabled) {
    tabs.push({
      id: 0,
      icon: <FlightTakeoffIcon />,
      component: HolidayMode
    });
  }

  if (endUserAppConfig.operationModeEnabled) {
    tabs.push({
      id: 1,
      icon: <TuneIcon />,
      component: OperationMode
    });
  }

  if (endUserAppConfig.reportingEnabled) {
    tabs.push({
      id: 2,
      icon: <ClipboardIcon />,
      component: ReportingView
    });
  }

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ position: 'fixed', top: 8, right: 8, zIndex: 1201 }}>
        <LanguageSwitcher />
      </Box>

      {consentSubmitted ? (
        <>
          <Box sx={{ flexGrow: 1, p: 3 }}>
            {tabs.map((tab, index) => (
              <Box
                key={tab.id}
                role="tabpanel"
                hidden={selectedTab !== index}
                id={`tabpanel-${index}`}
                aria-labelledby={`tab-${index}`}
                sx={{ p: 3 }}
              >
                {selectedTab === index && <tab.component />}
              </Box>
            ))}
          </Box>
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="fullWidth"
            sx={{ position: 'fixed', bottom: 0, width: '100%', backgroundColor: 'white' }}
          >
            {tabs.map(tab => (
              <Tab key={tab.id} icon={tab.icon} />
            ))}
          </Tabs>
        </>
      ) : (
        <ConsentForm setConsentSubmitted={setConsentSubmitted} />
      )}
    </Box>
  );
}

export default withTranslation()(EndUserApp);
